"use client";

import { cn } from "@/lib/utils";
import { Button } from "@heroui/react";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ArrowRight } from "lucide-react";
import { useOnboardingWithCleanup } from "./use-onboarding";
function OnboardingDialog() {
  const {
    step,
    setStep,
    isOpen,
    close,
    totalSteps
  } = useOnboardingWithCleanup();
  const stepContent = [{
    title: "Welcome to Viral Launch",
    description: "Get your first 100 customers in days, not months. Create launch content, run viral giveaways, and launch on 100+ platforms where successful startups get their first customers.",
    image: "https://viral.devassets.app/virallaunch-hero-image-dark.webp"
  }, {
    title: "Get Started - Create Your First Project",
    description: "Begin by creating a new project for your startup. This will be your central hub for managing all your launch content, campaigns, and platform submissions.",
    image: "https://viral.devassets.app/virallaunch-hero-image-dark.webp"
  }, {
    title: "Explore Our Templates",
    description: "Check out our proven templates for X posts, Product Hunt launches, Reddit content, and viral giveaway campaigns. These templates are based on successful startup launches.",
    image: "https://viral.devassets.app/virallaunch-hero-image-dark.webp"
  }, {
    title: "Get Support",
    description: "Access our comprehensive documentation, launch playbooks, and community resources to maximize your startup's launch success.",
    image: "https://viral.devassets.app/virallaunch-hero-image-dark.webp"
  }];
  const handleContinue = () => {
    if (step < totalSteps) {
      setStep(step + 1);
    }
  };
  if (!isOpen) return null;
  return <Dialog open={isOpen} onOpenChange={close} data-sentry-element="Dialog" data-sentry-component="OnboardingDialog" data-sentry-source-file="onboarding.tsx">
      <DialogContent className="gap-0 p-0 [&>button:last-child]:text-white" data-sentry-element="DialogContent" data-sentry-source-file="onboarding.tsx">
        <div className="p-2">
          <img className="w-full rounded-lg" src={stepContent[step - 1].image} width={382} height={216} alt={`${stepContent[step - 1].title} illustration`} />
        </div>
        <div className="space-y-6 px-6 pb-6 pt-3">
          <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="onboarding.tsx">
            <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="onboarding.tsx">{stepContent[step - 1].title}</DialogTitle>
            <DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="onboarding.tsx">
              {stepContent[step - 1].description}
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
            <div className="flex justify-center space-x-1.5 max-sm:order-1">
              {[...Array(totalSteps)].map((_, index) => <div key={index} className={cn("h-1.5 w-1.5 rounded-full bg-primary", index + 1 === step ? "bg-primary" : "opacity-20")} />)}
            </div>
            <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="onboarding.tsx">
              <DialogClose asChild data-sentry-element="DialogClose" data-sentry-source-file="onboarding.tsx">
                <Button type="button" variant="ghost" onClick={close} data-sentry-element="Button" data-sentry-source-file="onboarding.tsx">
                  Skip
                </Button>
              </DialogClose>
              {step < totalSteps ? <Button className="group" type="button" color="primary" onClick={handleContinue}>
                  Next
                  <ArrowRight className="-me-1 ms-2 opacity-60 transition-transform group-hover:translate-x-0.5" size={16} strokeWidth={2} aria-hidden="true" />
                </Button> : <DialogClose asChild>
                  <Button type="button" onClick={close}>
                    Okay
                  </Button>
                </DialogClose>}
            </DialogFooter>
          </div>
        </div>
      </DialogContent>
    </Dialog>;
}
export { OnboardingDialog };